import { ClbToast, ClbToastBase } from '@celebration/design-system-react';
import PropTypes from "prop-types";
import { createContext, useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { generateRandomNumber } from 'utils/calculations';

const ToastContainer = styled.div`
  position: fixed;
  z-index: 10000;
`;

const ToastContext = createContext();

const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState([]);
  const handleClose = useCallback(
    (id) => setToast((prevState) => prevState.filter((x) => x.id !== id)),
    []
  );
  const handleCloseWithTimeout = useCallback(
    (id, time) => setTimeout(() => handleClose(id), time),
    [handleClose]
  );

  const openToast = useCallback(
    (message, type = "positive", time = 10000) => {
      setToast((prevState) => {
        const id = generateRandomNumber();
        handleCloseWithTimeout(id, time);
        return [
          ...prevState,
          {
            open: true,
            message: message,
            type: type,
            id: id,
          },
        ];
      });
    },
    [handleCloseWithTimeout]
  );

  const values = useMemo(
    () => ({
      openToast,
    }),
    [openToast]
  );

  return (
    <ToastContext.Provider value={values}>
      {children}
      <ToastContainer>
        <ClbToast>
          <div style={{ display: "flex", flexDirection: "column-reverse" }}>
            {toast.map((x) => (
              <ClbToastBase
                key={x.id}
                type={x.type}
                description={x.message}
                open={x.open}
                onClbClickToastClose={() => handleClose(x.id)}
              />
            ))}
          </div>
        </ClbToast>
      </ToastContainer>
    </ToastContext.Provider>
  );
}

ToastProvider.propTypes = {
  children: PropTypes.any.isRequired
}

export { ToastProvider, ToastContext }
